import React from "react";
import { useNavigate } from "react-router-dom";
import storage from "../assets/js/Global";
import { images } from "../assets/images";

const NotFound = () => {
  const navigate = useNavigate();
  const loginObj = storage.get("user");
  const isAuthenticated = loginObj && loginObj.user_pid;

  return (
    <div
      style={{
        minHeight: "100vh",
        background: "var(--primaryColor)",
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        padding: "24px 16px",
      }}
    >
      {/* Logo */}
      <img
        src={images.appLogo}
        alt="Logo"
        style={{ height: "80px", objectFit: "contain", marginBottom: "20px" }}
      />

      {/* Illustration */}
      <svg
        width="220"
        height="160"
        viewBox="0 0 220 160"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        style={{ marginBottom: "28px" }}
      >
        {/* Ground */}
        <ellipse cx="110" cy="148" rx="90" ry="10" fill="#e2e8f0" />

        {/* Sign post */}
        <rect x="107" y="72" width="6" height="76" rx="3" fill="#cbd5e1" />

        {/* Sign board */}
        <rect x="68" y="40" width="84" height="38" rx="8" fill="#0d1831" />
        <text
          x="110"
          y="65"
          textAnchor="middle"
          fill="white"
          fontSize="18"
          fontWeight="800"
          fontFamily="system-ui, sans-serif"
        >
          404
        </text>

        {/* Direction arrows on sign */}
        <rect x="52" y="54" width="20" height="10" rx="4" fill="#3b82f6" />
        <polygon points="48,59 54,54 54,64" fill="#3b82f6" />
        <rect x="148" y="54" width="20" height="10" rx="4" fill="#ef4444" />
        <polygon points="172,59 166,54 166,64" fill="#ef4444" />

        {/* Character (lost person) */}
        {/* Body */}
        <rect x="88" y="95" width="18" height="28" rx="6" fill="#6366f1" />
        {/* Head */}
        <circle cx="97" cy="89" r="10" fill="#fbbf24" />
        {/* Eyes */}
        <circle cx="93" cy="88" r="1.5" fill="#1e293b" />
        <circle cx="101" cy="88" r="1.5" fill="#1e293b" />
        {/* Confused mouth */}
        <path
          d="M93 93 Q97 91 101 93"
          stroke="#1e293b"
          strokeWidth="1.2"
          fill="none"
          strokeLinecap="round"
        />
        {/* Question mark above head */}
        <text
          x="112"
          y="82"
          fill="#6366f1"
          fontSize="16"
          fontWeight="700"
          fontFamily="system-ui, sans-serif"
        >
          ?
        </text>
        {/* Legs */}
        <rect x="88" y="120" width="7" height="22" rx="3" fill="#4f46e5" />
        <rect x="99" y="120" width="7" height="22" rx="3" fill="#4f46e5" />
        {/* Shoes */}
        <rect x="85" y="139" width="12" height="6" rx="3" fill="#1e293b" />
        <rect x="96" y="139" width="12" height="6" rx="3" fill="#1e293b" />

        {/* Map in hand */}
        <rect
          x="62"
          y="100"
          width="28"
          height="20"
          rx="3"
          fill="white"
          stroke="#cbd5e1"
          strokeWidth="1.5"
        />
        <line
          x1="67"
          y1="106"
          x2="84"
          y2="106"
          stroke="#94a3b8"
          strokeWidth="1"
        />
        <line
          x1="67"
          y1="110"
          x2="80"
          y2="110"
          stroke="#94a3b8"
          strokeWidth="1"
        />
        <line
          x1="67"
          y1="114"
          x2="76"
          y2="114"
          stroke="#94a3b8"
          strokeWidth="1"
        />
        {/* Arm holding map */}
        <rect x="76" y="103" width="14" height="6" rx="3" fill="#6366f1" />

        {/* Stars/sparkles */}
        <circle cx="40" cy="30" r="2.5" fill="#fbbf24" opacity="0.7" />
        <circle cx="175" cy="20" r="3" fill="#6366f1" opacity="0.6" />
        <circle cx="160" cy="45" r="1.8" fill="#ef4444" opacity="0.5" />
        <circle cx="30" cy="70" r="2" fill="#3b82f6" opacity="0.5" />
      </svg>

      {/* Text */}
      <h2
        className="fw-bold mb-2 text-center"
        style={{ color: "var(--secondaryColor)", fontSize: "26px" }}
      >
        Oops! Page Not Found
      </h2>
      <p
        className="text-center mb-4"
        style={{
          color: "#9ea9b9",
          fontSize: "14px",
          maxWidth: "320px",
          lineHeight: "1.7",
        }}
      >
        Looks like you've taken a wrong turn. The page you're looking for
        doesn't exist or has been moved.
      </p>

      <button
        className="btn btn-secondary px-5"
        style={{ borderRadius: "12px", height: "44px", fontWeight: "600" }}
        onClick={() => navigate(isAuthenticated ? "/home" : "/login")}
      >
        {isAuthenticated ? "Back to Home" : "Go to Login"}
      </button>
    </div>
  );
};

export default NotFound;
